<div class="case-details-div">
    <div class="case-applicant-div">
        <div class="case-heading-div">Applicant</div>
        <div class="case-single-line">
            <div>Application Ref</div>
            <div>{{application.reference}}</div>
        </div>
        <div class="case-single-line">
            <div>ID Number</div>
            <div>{{application.user.idNumber}}</div>
        </div>
        <div class="case-single-line">
            <div>SASSA Funded</div>
            <div>{{application.sassaFunded ? 'Yes' : 'No'}}</div>
        </div>
        <div class="case-single-line">
            <div>Disabled</div>
            <div>{{application.disabled ? 'Yes' : 'No'}}</div>
        </div>
        <div class="case-single-line">
            <div>Year of study</div>
            <div>{{application.year}}</div>
        </div>        
    </div>
    <div class="case-applicant-div" *ngFor="let careGiver of careGivers, let i = index">
        <div class="case-heading-div">{{careGiverType[i]}}</div>        
        <div class="case-single-line">
            <div>ID Number</div>
            <div>{{careGiver.idNumber}}</div>
        </div>
        <div class="case-single-line">
            <div>Names</div>
            <div>{{careGiver.firstName}}</div>
        </div>
        <div class="case-single-line">
            <div>Surname</div>
            <div>{{careGiver.lastName}}</div>
        </div>
        <div class="case-single-line">
            <div>Annual gross income</div>
            <div>{{careGiver.income}}</div>
        </div>
        <div class="case-single-line">
            <div>Alive status</div>
            <div>{{careGiver.alive ? 'Yes' : 'No'}}</div>
        </div>
        <div class="case-single-line">
            <div>Verified</div>
            <div>{{careGiver.validated ? 'Yes' : 'No'}}</div>
        </div>
    </div>
</div>
